import { connect } from "react-redux";

import { get_affiliates } from "./queries";
import { create_affiliate } from "./commands";

function mapStateToProps(state) {
  return { affiliates: state.affiliates };
}

function mapDispatchToProps(dispatch) {
  return {
    createAffiliate: (ownerPersonId, affiliateName) => {
      dispatch(create_affiliate(ownerPersonId, affiliateName));
    },

    getAffiliates: () => {
      dispatch(get_affiliates());
    },
  };
}

const affiliatesConnector = connect(mapStateToProps, mapDispatchToProps);
export default affiliatesConnector;
